import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import AppLayout     from '../components/AppLayout.vue'
import SearchView    from '../components/SearchView.vue'
import ScannerView   from '../components/ScannerView.vue'
import PurchasesView     from '../components/PurchasesView.vue'
import FidelityCardsView from '../components/FidelityCardsView.vue'
import LoginView         from '../components/LoginView.vue'
import RegisterView      from '../components/RegisterView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        { path: '',        name: 'search',    component: SearchView },
        { path: 'scanner', name: 'scanner',  component: ScannerView },
        { path: 'achats',  name: 'achats',   component: PurchasesView },
        { path: 'cartes',  name: 'cartes',   component: FidelityCardsView },
      ],
    },
    { path: '/login',    name: 'login',    component: LoginView },
    { path: '/register', name: 'register', component: RegisterView },
  ],
})

router.beforeEach((to) => {
  const auth = useAuthStore()

  if (to.meta.requiresAuth && !auth.user) {
    return { name: 'login' }
  }

  if ((to.name === 'login' || to.name === 'register') && auth.user) {
    return { name: 'search' }
  }
})

export default router
